import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ContactPartner from './contactPartner';
import ContactProduct from './contactProduct';

const ContactPage = () => {
  const { pathname } = useLocation();
  const [pagePart, setPagePart] = useState('pro');

  useEffect(() => {
    if (pathname === '/contact-us/product' || pathname === '/contact-us/product/contact-us') {
      setPagePart('pro');
    }
    if (pathname === '/contact-us/partner' || pathname === '/contact-us/partner/contact-us') {
      setPagePart('part');
    }
  }, [pathname]);

  return (
    <>
      {pagePart === 'pro' && <ContactProduct />}
      {pagePart === 'part' && <ContactPartner />}
    </>
  );
};

export default ContactPage;
